module.exports = __webpack_public_path__ + "static/media/lainie.e14fea12.woff";